"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractMintButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const mint_json_1 = __importDefault(require("@framework/abis/json/ERC20Simple/mint.json"));
const mintCommon_json_1 = __importDefault(require("@framework/abis/json/ERC721Simple/mintCommon.json"));
const mint_json_2 = __importDefault(require("@framework/abis/json/ERC1155Simple/mint.json"));
const constants_1 = require("@framework/constants");
const utils_1 = require("../../../../utils");
const dialogs_1 = require("../../../../dialogs");
const dialog_1 = require("./dialog");
const ContractMintButton = (props) => {
    const { className, contract, contract: { address, id: contractId, contractFeatures, contractType, decimals, accessControls }, disabled, variant, } = props;
    const { address: account = "" } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.MINTER_ROLE);
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        const templateComponent = values.template.components[0];
        if (templateComponent.tokenType === types_1.TokenType.ERC20) {
            return writeContractAsync({
                address: templateComponent.contract.address,
                abi: mint_json_1.default,
                functionName: "mint",
                args: [values.account, BigInt(templateComponent.amount)],
            });
        }
        else if (templateComponent.tokenType === types_1.TokenType.ERC721 || templateComponent.tokenType === types_1.TokenType.ERC998) {
            return writeContractAsync({
                address: templateComponent.contract.address,
                abi: mintCommon_json_1.default,
                functionName: "mintCommon",
                args: [values.account, BigInt(templateComponent.templateId)],
            });
        }
        else if (templateComponent.tokenType === types_1.TokenType.ERC1155) {
            return writeContractAsync({
                address: templateComponent.contract.address,
                abi: mint_json_2.default,
                functionName: "mint",
                args: [
                    values.account,
                    BigInt(templateComponent.template.tokens[0].tokenId),
                    BigInt(templateComponent.amount),
                    "0x",
                ],
            });
        }
        else {
            throw new Error("unsupported token type");
        }
    });
    const handleMintTokenConfirmed = async ({ data }) => {
        await metaFn(data);
    };
    const initialValues = {
        template: {
            components: [
                {
                    tokenType: contractType,
                    contractId,
                    contract: {
                        decimals,
                        address,
                        contractType,
                    },
                    template: {
                        id: 0,
                        tokens: [],
                    },
                    tokenId: 0,
                    templateId: 0,
                    amount: contractType === types_1.TokenType.ERC20 ? constants_1.WeiPerEther.toString() : "1",
                },
            ],
        },
        account,
    };
    const handleMintToken = () => {
        openDialog(dialogs_1.GlobalDialogKeys.CONTRACT_MINT, contract, {
            initialValues,
            validationSchema: dialog_1.mintTokenValidationSchema,
            message: "dialogs.mintToken",
            testId: "MintForm",
            onExternalConfirm: handleMintTokenConfirmed,
            componentProps: {
                initialValues,
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleMintToken, icon: icons_material_1.AddCircleOutline, message: "form.buttons.mintToken", className: className, dataTestId: "ContractMintButton", disabled: disabled ||
            (0, utils_1.shouldDisableByContractType)(contract) ||
            contractType === types_1.TokenType.NATIVE ||
            contractFeatures.includes(types_1.ContractFeatures.GENES) ||
            !hasPermission, variant: variant }));
};
exports.ContractMintButton = ContractMintButton;
//# sourceMappingURL=index.js.map